<template>
    <div class="preloader">

        <div class="wrapper">

            <div class="ring" v-bind:class="{ '-paused': !isPageLoading }">

                <div class="wave-left" v-el:wave-left></div>

                <div class="speaker">
                    <img src="../assets/images/preloader-speaker.svg" data-fallback-src="../assets/images/preloader-speaker.png" alt="Turn your sound up">
                </div>

                <div class="wave-right" v-el:wave-right></div>

            </div>

            <div class="text" v-if="isSoundSupported">Turn your sound up for the best experience</div>
            <div class="text" v-else>Loading in progress</div>

        </div>

        <div class="backoverlay"></div>

    </div>
</template>

<script>
    import Spritz from 'babel!../libs/spritz.js'

    export default {
        props: ['isPageLoading'],

        vuex: {
            getters: {
                isSoundSupported: state => state.isSoundSupported
            }
        },

        watch: {
            isPageLoading: 'updateSpriteState'
        },

        data: function () {
            return {
                waveSpriteLeft: false,
                waveSpriteRight: false
            }
        },

        ready: function () {
            this.createSprite()
        },

        methods: {
            'updateSpriteState': function () {
                if (this.waveSpriteLeft !== false && this.waveSpriteRight !== false) {
                    if (this.isPageLoading) {
                        this.waveSpriteLeft.play(25)
                        this.waveSpriteRight.play(25)
                    } else {
                        this.waveSpriteLeft.pause()
                        this.waveSpriteRight.pause()
                    }
                }
            },

            'createSprite': function () {
                this.waveSpriteLeft = Spritz({
                    container: this.$els.waveLeft,
                    src: '/static/sprites/preloader-wave.png',
                    width: 200,
                    height: 225,
                    steps: 6,
                    rows: 3,
                    displayMode: 'fluid'
                }).init().play(25)

                this.waveSpriteRight = Spritz({
                    container: this.$els.waveRight,
                    src: '/static/sprites/preloader-wave.png',
                    width: 200,
                    height: 225,
                    steps: 6,
                    rows: 3,
                    flip: true,
                    displayMode: 'fluid'
                }).init(3).play(25)
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    $preloader-ring-img-size: 29px;
    $preloader-ring-size: 76px;
    $preloader-ring-thickness: 2px;
    $preloader-ring-speed: 1.25s;

    .v-loading .preloader {
        transition: opacity 0s ease-out 0s, left 0s linear 0s;
        opacity: 1;
        left: 0;

        .backoverlay {
            transition: transform 0s ease-out;
            transform: translateY(0);
        }

        .wrapper {
            transition: opacity 0s ease-out 0s;
            opacity: 1;
        }
    }

    .preloader {
        transition: opacity 0s ease-out .6s, left 0s linear .6s;
        display: block;
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        left: -9999px;
        opacity: 0;

        .backoverlay {
            position: absolute;
            z-index: 2;
            transition: transform .5s ease-in;
            transform: translateY(-100%);
            width: 100vw;
            height: 100vh;
            background-color: $dark-black;
        }

        .wrapper {
            @include middlePos();
            transition: opacity 0.2s ease-out 0.2s;
            z-index: 5;
            opacity: 0;
        }

        .wave-left,
        .wave-right {
            display: block;
            position: absolute;
            top: 50%;
            height: 75px;
            width: 100px;
        }

        .wave-left {
            left: 0;
            margin-left: -0.25rem;
            transform: translateX(-100%) translateY(-50%);
        }
        .wave-right {
            left: 100%;
            margin-left: 0.25rem;
            transform: translateY(-50%);
        }

        .ring {
            padding: 1.25rem;
            display: block;
            margin: auto;
            position: relative;
            border: $preloader-ring-thickness solid $white;
            width: $preloader-ring-size;
            height: $preloader-ring-size;
            border-radius: 50%;

            &::after {
                position: absolute;
                top: -$preloader-ring-thickness;
                left: -$preloader-ring-thickness;
                content: ' ';
                width: $preloader-ring-size;
                height: $preloader-ring-size;
                border: $preloader-ring-thickness + 1px solid $towards-blue;
                border-radius: 50%;
                box-sizing: border-box;
                clip: rect(0, $preloader-ring-size + $preloader-ring-thickness, ($preloader-ring-size + $preloader-ring-thickness) / 2, ($preloader-ring-size + $preloader-ring-thickness) / 2);
                animation: preloader-rotation $preloader-ring-speed linear infinite;
            }

            &.-paused {
                &::after {
                    animation-play-state: paused;
                }
            }
        }

        .speaker {
            @include middlePos();
            width: $preloader-ring-img-size;
            height: $preloader-ring-img-size;
        }

        .text {
            @include headingsStyle();
            letter-spacing: 4px;
            color: $white;
            margin-top: 1.35rem;
            font-size: 0.85rem;
            text-align: center;
        }
    }

    @keyframes preloader-rotation {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// Preloader.vue?050e5ff4